import React from 'react';
import BaseContainer from "../containers/common/BaseContainer";
import ReportForm from "../containers/ReportForm";


const ReportPage = () => {
    return (
        <>
            <BaseContainer sidebar={true}>
                <ReportForm />
            </BaseContainer>
        </>
    )
};

export default ReportPage;
